import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";
import "./index.css";
import cover from "../../../Assets/img/default-cover-image.svg";
import Skeleton from "react-loading-skeleton";

class GalleryCard extends Component {
  render() {
    return (
      <div className="shadow-sm rounded mb-2 th-gallery-card">
        {this.props.loading ? (
          <Skeleton className="th-gallery-card-img" />
        ) : (
          <div
            className="th-gallery-card-img"
            style={{
              backgroundImage: `url(${
                this.props.img ? this.props.img : cover
              })`,
            }}
          ></div>
        )}
      </div>
    );
  }
}
export default GalleryCard;
